import { render, staticRenderFns } from "./MonitObserveTaskList.vue?vue&type=template&id=834c4fbc&"
import script from "./MonitObserveTaskList.vue?vue&type=script&lang=js&"
export * from "./MonitObserveTaskList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports